export class DatevEndpoint {
    type = "";
    name = "";
    description = "";
    parents: string[];
    dupKeyFields: string[];
    queryParams = "";
}
